import React from 'react';
import { getParams } from '@chat/utils';
import Default from '../Default';

function index(): JSX.Element {
    const searchParams = window.location?.search.substring(1);
    const code = +getParams(searchParams, 'code');
    return <Default code={code} />;
}

export default index;
